import React, { useState, useEffect } from 'react';
import { Tooltip } from './ui';
import { ArrowUp } from 'lucide-react';

interface BackToTopProps {
  threshold?: number;
}

const BackToTop: React.FC<BackToTopProps> = ({ threshold = 300 }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShow(window.scrollY > threshold);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [threshold]);

  const handleClick = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  if (!show) return null;

  return (
    <Tooltip title="Back to top">
      <button
        onClick={handleClick}
        aria-label="scroll back to top"
        className="fixed bottom-20 sm:bottom-4 left-4 z-[1000] bg-green-700 hover:bg-green-800 text-white rounded-full p-2 shadow-lg transition-all duration-300 transform hover:scale-110"
      >
        <ArrowUp className="w-5 h-5" />
      </button>
    </Tooltip>
  );
};

export default BackToTop;
